import { Form, Button } from 'react-bootstrap';
import { useState, useRef } from 'react';
import Axios from '@/shared/api/axios';
import { useDispatch } from "react-redux";
import { setNickName } from "@/shared/store/slices/userSlice";
import { Link } from 'react-router-dom';
import StatusModal from '@/components/ui/StatusModal';
import { getErrorMessageKey } from '@/shared/constants/errorCodes';
import LoadingButton from '@/components/ui/LoadingButton';
import { useTranslation } from 'react-i18next';

import {
    Card,
} from 'react-bootstrap';

// 會員登入表單
function Nickname({ onResponse }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [firstNickName, setFirstNickName] = useState(null);
    const [validated, setValidated] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [next, setNext] = useState(false);
    const [idolUuid, setIdolUuid] = useState(null);

    // API 非成功狀態碼統一由單一 StatusModal 顯示。
    // 原本是每個碼各掛一個 ref 的靜態寫法，只認事先列舉的 5 個碼；
    // 攔截器附加的 HTTP_403/404/413/429/503 與 TIMEOUT_ERROR 都不在名單內，
    // 建立偶像失敗時只會在 console 留一行 warn，畫面上完全沒有提示。
    const statusModalRef = useRef(null);
    const [currentStatusCode, setCurrentStatusCode] = useState('');
    // onResponse 失敗時偶像其實已建立，錯誤訊息要補充說明，避免使用者再按一次重複建立
    const [isIdolCreated, setIdolCreated] = useState(false);

    let errorMsg = t('create_idol_message');

    const handleChange = e => {
        setFirstNickName(({
            nick_name: e.target.value,
        }))
    }
    
    const handleSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const formCheck = event.currentTarget;
        if (formCheck.checkValidity() === false) {
            setValidated(true);
            return;
        }

        setIsSubmitting(true);
        let isCreated = false;
        try {
            const res = await Axios.post("/idol/create", firstNickName);

            if (res.data.status_code === 'SYSTEM_1000') {
                isCreated = true;
                if (onResponse) {
                    dispatch(setNickName(firstNickName.nick_name));
                    // await：onResponse 的後續請求也納入 isSubmitting，避免重複建立；其例外交給下方標準 catch。
                    // onResponse 可回傳 status_code，非成功時由此處 StatusModal 顯示（NETWORK_ERROR 由全域處理）
                    const resultCode = await onResponse(res);
                    if (resultCode !== undefined && resultCode !== 'SYSTEM_1000' && resultCode !== 'NETWORK_ERROR') {
                        setIdolCreated(true);
                        setCurrentStatusCode(resultCode);
                        statusModalRef.current?.show();
                    }
                } else {
                    setIdolUuid(res.data.idol_uuid);
                    setNext(true);
                }
            } else {
                setIdolCreated(false);
                setCurrentStatusCode(res.data.status_code);
                statusModalRef.current?.show();
            }
        } catch (error) {
            // HTTP 錯誤（如名稱過長導致的 500）由攔截器附上 httpErrorCode，這裡顯示對應 StatusModal，不再靜默
            // NETWORK_ERROR 由全域 ServerErrorPage 處理，不另外顯示 modal
            if (error.httpErrorCode && error.httpErrorCode !== 'NETWORK_ERROR') {
                // 例外可能來自 /idol/create 或 onResponse 的後續請求，以是否已拿到建立結果區分
                setIdolCreated(isCreated);
                setCurrentStatusCode(error.httpErrorCode);
                statusModalRef.current?.show();
            } else if (!error.httpErrorCode) {
                console.error('Create idol error:', error);
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return ( <>
        <Card.Title className="loginbox-title text-center border-bottom">
            <h2 className="p-3">{t('create_idol')}</h2>
        </Card.Title>
        <Card.Body className="py-3 px-4">
        { next ? 
        (<><h5 className='mb-3'>{t('continue_edit')}</h5>
        <div className="d-flex gap-3 mx-auto">
            <div className="w-100">
            <Link to="/">
                <Button  className="w-100" variant="secondary">{t('no')}</Button>
            </Link>
            </div>
            <div className="w-100">
            <Link to={`/idol-update/${idolUuid}`}>
                <Button  className="w-100 btn-primaryF">{t('yes')}</Button>
            </Link>
            </div>
        </div>
        </>
        ) : 
        (<Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group className="mb-3" >
                <Form.Label>{t('nickname')}<span className="require-star">*</span></Form.Label>
                <Form.Control
                    onChange={handleChange}
                    type="text"
                    name="nickname"
                    placeholder={errorMsg}
                    pattern="^\S{1,100}$"
                    maxLength={100}
                    required
                />
                <Form.Control.Feedback type="invalid">{t('nickname_invalid')}</Form.Control.Feedback>
            </Form.Group>
            <div className="">
                <LoadingButton
                    className="btn btn-primary btn-lg w-100 mb-3 btn-primaryF"
                    type="submit"
                    isLoading={isSubmitting}
                    disabled={!firstNickName || !firstNickName.nick_name || firstNickName.nick_name.trim() === ''}
                >
                    {t('create')}
                </LoadingButton>
            </div>
        </Form>) }
        </Card.Body>
        <StatusModal ref={statusModalRef} statusCode={currentStatusCode}>
            {isIdolCreated && (<>
                <p>{t(getErrorMessageKey(currentStatusCode))}</p>
                <p className="mb-0">{t('idol_created_switch_failed')}</p>
            </>)}
        </StatusModal>
        </>
    );
}

export default Nickname;